import { render } from "./RegisteredTradesScrapingListing.vue?vue&type=template&id=67d110aa&ts=true"
import script from "./RegisteredTradesScrapingListing.vue?vue&type=script&lang=ts"
export * from "./RegisteredTradesScrapingListing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__